import BaseModel from '../core/BaseModel'
export default class AppraisalProductModel extends BaseModel {
    constructor() {
        super({ 
                name: "appraisal_product",
                tableName: 'core_appraisal_product'
            }, 
            {
            id: { 
                name: 'id', 
                type: "String", 
                label: 'ID', 
                primaryKey: true,
                display: false
            },
            serviceCode: { 
                name: 'full_name', 
                type: "String", 
                label: 'Mã dịch vụ',
                sortable: true,
                width: 15,
                filter: { type: 'input',  match: 'custom'},
                computed: (data) => {
                    data.serviceCode = '';
                }
            },
            created_date: { 
                name: 'created_date', 
                type: "CustomDateTime", 
                label: 'Thời gian tạo',
                class: 'top-datepicker',
                sortable: true,
                width: 15,
                filter: { type: 'DateRange', match: 'custom'}
            },
            organizationRequest: { 
                name: 'organizationRequest', 
                label: 'Đơn vị yêu cầu',
                class: 'center',
                type: "Text",
                sortable: true,
                width: 15,
                computed: (data) => {
                    data.organizationRequest = '';
                }
            },
            organizationAppraisal: { 
                name: 'organizationAppraisal', 
                label: 'Đơn vị thẩm định',
                class: 'center',
                type: "Text",
                sortable: true,
                width: 15,
                computed: (data) => {
                    data.organizationAppraisal = '';
                }
            },
            processStatus: {
                name: 'processStatus', label: 'Trạng thái xử lý', type: "Selection",  dataType: 'Label',  class: 'center', width: 15,
                options: [{ value: 1, label: 'Đã xử lý'}, { value: 0, label: 'Chờ xử lý'}],
                filter: { type: 'select', display: false, optionLabel: 'label', optionKey: 'value', match: 'equals' },
                sortable: true,
                computed: (data) => {
                    data.processStatus = 0;
                }
            },
            products: { 
                name: 'products', 
                label: 'Sản phẩm đã xử lý',
                class: 'center',
                width: 12,
                sortable: true,
                computed: (data) => {
                    data.products ='0/0';
                }
            },
            user_id: {
                refs: 'request_return_product_id',
                display: false
            },
            fied_detail: {
                refs: ' appraisal_id',
                display: false
            },
        },)
    }

}